<app-base-modal title="{{ 'REGISTER.MODAL_TITLE' | translate }}" [showClose]="showClose" (closeCross)="onCloseModal()">
  <ng-container modal-body-content>
    <div [innerHTML]="termsHtml"></div>
  </ng-container>
  @if (showBtns) {
    <ng-container modal-footer-content>
      <div class="accept-documents-container">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="chk-terms" [(ngModel)]="acceptedTerms" />
          <label class="form-check-label" for="chk-terms">
            {{ 'REGISTER.ACCEPT_DOC_PREFIX' | translate }}
            <a [href]="termsPdfUrl" target="_blank" rel="noopener noreferrer">{{
              'REGISTER.TERMS_LINK_TEXT' | translate
            }}</a>
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="chk-privacy" [(ngModel)]="acceptedPrivacy" />
          <label class="form-check-label" for="chk-privacy">
            {{ 'REGISTER.ACCEPT_DOC_PREFIX' | translate }}
            <a [href]="privacyPdfUrl" target="_blank" rel="noopener noreferrer">{{
              'REGISTER.PRIVACY_LINK_TEXT' | translate
            }}</a>
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="chk-cookie" [(ngModel)]="acceptedCookies" />
          <label class="form-check-label" for="chk-cookie">
            {{ 'REGISTER.ACCEPT_DOC_PREFIX' | translate }}
            <a [href]="cookiePdfUrl" target="_blank" rel="noopener noreferrer">{{
              'REGISTER.COOKIE_LINK_TEXT' | translate
            }}</a>
          </label>
        </div>
      </div>
      @if (!isLoading) {
        <div class="d-flex align-items-center w-100 justify-content-end">
          <button
            type="button"
            ngbAutofocus
            class="btn btn-accept"
            [disabled]="!allAccepted"
            (click)="onBtnClick('accept')"
          >
            {{ 'COMMON.ACCEPT_TERMS_AND_CONDITIONS' | translate }}
          </button>
        </div>
      } @else {
        <div class="d-flex w-100 justify-content-center">
          <div class="spinner-border" role="status"></div>
        </div>
      }
      <ng-template #spinner>
        <div class="d-flex w-100 justify-content-center">
          <div class="spinner-border" role="status"></div>
        </div>
      </ng-template>
    </ng-container>
  }
  @if (showPdfLinks) {
    <ng-container modal-footer-content>
      <div class="pdf-links-container">
        <span class="form-check-label">
          {{ 'REGISTER.ACCEPT_DOC_PREFIX' | translate }}
          <a [href]="termsPdfUrl" target="_blank" rel="noopener noreferrer">{{
            'REGISTER.TERMS_LINK_TEXT' | translate
          }}</a>
        </span>
        <span class="form-check-label">
          {{ 'REGISTER.ACCEPT_DOC_PREFIX' | translate }}
          <a [href]="privacyPdfUrl" target="_blank" rel="noopener noreferrer">{{
            'REGISTER.PRIVACY_LINK_TEXT' | translate
          }}</a>
        </span>
        <span class="form-check-label">
          {{ 'REGISTER.ACCEPT_DOC_PREFIX' | translate }}
          <a [href]="cookiePdfUrl" target="_blank" rel="noopener noreferrer">{{
            'REGISTER.COOKIE_LINK_TEXT' | translate
          }}</a>
        </span>
      </div>
    </ng-container>
  }
</app-base-modal>
